import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import {loginSuccessC} from '../redux/slices/singleCattleSlice'
import { useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import { useForm,Controller } from "react-hook-form";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import apiService from "../api/ApiService";
import { Close, DateRange, Female, Home, Place, Sell } from '@mui/icons-material';
const moment=require('moment-jalaali');
export function isEqual(obj1, obj2) {
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return obj1 == obj2;
  }

  if (obj1 === null || obj2 === null) {
    return obj1 == obj2;
  }

  const obj1Keys = Object.keys(obj1).sort();
  const obj2Keys = Object.keys(obj2).sort();

  if (obj1Keys.length !== obj2Keys.length) {
    return false;
  }

  for (let i = 0; i < obj1Keys.length; i++) {
    const key = obj1Keys[i];
    if (!isEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

const EditModalDam=({data})=>{
    const [valid,setValid]=useState(false)
    const {currentAdmin}=useSelector(state=>state.p.admin)
    const firstdate={year:+data?.birthdate?.substring(0,4),month:+data?.birthdate?.substring(5,7),day:+data?.birthdate?.substring(8,10)}
    const datee=moment(`${firstdate.year}-${firstdate.month}-${firstdate.day}`).format('jYYYY-jMM-jDD')
    const finaldate={year:+datee?.substring(0,4),month:+datee?.substring(5,7),day:+datee?.substring(8,10)}
    const mainProp={gender:data?.gender,earTagNumber:data?.earTagNumber,bodyNumber:data?.bodyNumber,birthdate:finaldate,penId:data?.pen?.id,sensorNecklaceNumber:data?.sensor?.necklaceNumber}
    const dispatch=useDispatch()
    const {currentCattle}=useSelector(state=>state.cattle)
    const [AllPens,setAllPen]=useState([]);
    const [activeSensors,setActiveSensor]=useState([]);
    const {watch,
      control,
        register,
        handleSubmit,
        formState: { errors }
      } = useForm({
        defaultValues: mainProp
     });
     console.log(mainProp);
      const allData=watch();
      
      useEffect(()=>{
        setValid(isEqual(mainProp,allData))
      },[allData])
    const getPens=async()=>{
            
              const data1=JSON.stringify({
                "skip":-1,
                "take": -1,
                "fromDate": null,
                "toDate": null,
                "isActive": true
              })   
              const data2=JSON.stringify({
                "skip":-1,
                "take": -1,
                "fromDate": null,
                "toDate": null,
                "isActive": true,
                "hasCattle":false,
                "farmIds":[currentAdmin?.id]
              })   
              
                    const res2=await apiService.getDataFarm(data2)
                    setActiveSensor(res2.data.data)
                    const res=await apiService.getPens(currentAdmin.id,data1)
                    const filter=res.data.data.filter(item=>{
                      return item.id!==data?.pen?.id
                    })
                    setAllPen(filter)

                  
          
        }
useEffect(()=>{
    getPens()
},[])
    const {isOpenModal,closeModalls,openModalls}=useGlobalContext();
    const updateCattle=async(data)=>{
        const geregorian=moment(`${data?.birthdate?.year}-${data?.birthdate?.month}-${data?.birthdate?.day}`,'jYYYY-jMM-jDD').format('YYYY-MM-DD')
        const nullabel=data?.sensorNecklaceNumber==='null'?JSON.parse(data?.sensorNecklaceNumber):data?.sensorNecklaceNumber
        const data1=JSON.stringify({...data,birthdate:geregorian,gender:+data?.gender,sensorNecklaceNumber:nullabel})
                const res=await apiService.updateCattle(currentCattle.id,data1)
                dispatch(loginSuccessC(res.data))
                openModalls()
    }

    

    return <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <form onSubmit={handleSubmit(updateCattle)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <DriveFileRenameOutlineIcon fontSize="large"/>

            <h4 >  به روز رسانی مشخصات دام</h4>
            </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a"  {...register("earTagNumber")}/>
            <label for="" className={'labelSS'}><Sell fontSize='small'/> شماره گوش  </label>
            {errors.earTagNumber&&<span className='errMsg'>این مقدار ضروری است</span>}

        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("bodyNumber")}/>
            <label for="" className={'labelSS'}><Sell fontSize='small'/> شماره بدن</label>
            {errors.bodyNumber&&<span className='errMsg'>این مقدار ضروری است</span>}

        </div>
        
        <div class="inputContainerSS3">
        
                           
                           <Controller
                           control={control}
                           name="birthdate"
                           rules={{ required: true }}
                           render={({ field: { onChange, value } }) => (
                           <DatePicker
                           value={value}
                           onChange={onChange}
                           inputPlaceholder={'تاریخ تولد'}
                             locale='fa'
                             inputClassName='inputSSS'
                             calendarClassName="birthCalender"
                             />)}
                             />
                           <label for="" className={'labelSSS'} >  <DateRange fontSize='small'/>تاریخ تولد :  </label>
                              {errors.birthdate&&<span className='errMsg'>این مقدار ضروری است</span>}
                       </div>
       
        <div className="SelConn">
        <label for='sele' ><Home fontSize='small'/> جایگاه:</label>
        <select  id='sele'  name='sele' className="selectInp"{...register("penId", {
              required: true
            })}  >
            <option  value={data?.pen?.id}>{data?.pen?.name}</option>
            {AllPens.map((item,index)=>{
                return <option key={index} value={item.id}>{item.name}</option>
            })}
        </select>
        </div>
        {errors.penId&&<span>این مقدار ضروری است</span>}
        <div className="SelConn">
        <label for='sele' ><Sell fontSize='small'/> گردنبند:</label>
        <select  id='sele'  name='sele' className="selectInp" {...register("sensorNecklaceNumber",{required:true})}  >
            {[{necklaceNumber:mainProp.sensorNecklaceNumber},...activeSensors].map((item,index)=>{
                return <option key={index} defaultValue={item.necklaceNumber} value={item.necklaceNumber}>{item.necklaceNumber}</option>
            })}
                    <option  value={null}>null</option>

        </select>
        {errors.sensorNecklaceNumber&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        <div className="SelConn">
        <label for='sele' ><Female fontSize='small'/> جنسیت:</label>
        <select id='sele' name='sele' className="selectInp" {...register("gender", {
              required: true
            })}>
            
            <option value={1}>
                نر
            </option>
            <option value={2}>
                ماده
            </option>
        </select>
        {errors.gender&&<span className='errMsg'>این مقدار ضروری است</span>}
        </div>
        <button type='submit' disabled={valid} className="EditMOdalBtnForm" >
            به روز رسانی
        </button>
        </form>


    </div>
}
export default EditModalDam